import { useThreads } from '@liveblocks/react/suspense'
import { Composer, Thread } from '@liveblocks/react-ui'
import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'
import { useEffect, useRef } from 'react'

interface GeneralCommentDialogProps {
  onVisibilityChange?: (isVisible: boolean) => void
}

export const GeneralCommentDialog = ({ onVisibilityChange }: GeneralCommentDialogProps) => {
  const { threads } = useThreads()
  const dialogRef = useRef<HTMLDivElement>(null)

  const currentUser = useSelector((state: RootState) => state.Auth.user)

  const userId = currentUser?.uuid?.toString() || 'unknown id'
  const userName = currentUser?.name || 'unknown user'

  const threadToDisplay =
    threads.filter(thread => !thread.resolved && thread.metadata?.type === 'general') ?? []

  useEffect(() => {
    if (!dialogRef.current || !onVisibilityChange) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry) {
          onVisibilityChange(entry.isIntersecting)
        }
      },
      { threshold: 0.5 },
    )

    observer.observe(dialogRef.current)

    return () => {
      observer.disconnect()
    }
  }, [onVisibilityChange])

  return (
    <div className="my-4 mt-auto pt-4 pr-6 pl-7" ref={dialogRef}>
      {threadToDisplay.map(thread => (
        <Thread
          showAttachments={false}
          showReactions={false}
          showActions={true}
          key={thread.id}
          thread={thread}
          className="thread"
        />
      ))}
      {!threadToDisplay.length && (
        <Composer
          showAttachments={false}
          className="composer"
          style={{ marginTop: 14 }}
          metadata={{
            listValueId: '',
            userId,
            userName,
            type: 'general',
            prevValue: '',
            currentValue: '',
          }}
        />
      )}
    </div>
  )
}
